import { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
    ArrowLeftIcon,
    ArrowRightIcon,
    MagnifyingGlassIcon,
    EllipsisVerticalIcon,
    EyeIcon,
    TicketIcon,
    PencilIcon,
} from '@heroicons/react/20/solid'
import { Badge } from 'components/badge'
import { Divider } from 'components/divider'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/table'
import { Input, InputGroup } from 'components/input'
import { useMutation } from '@apollo/client'

import {
    Dropdown,
    DropdownButton,
    DropdownDivider,
    DropdownItem,
    DropdownLabel,
    DropdownMenu,
} from 'components/dropdown'

import { useLazyQuery } from '@apollo/client'
import { GET_MASTER_ROUTE_LIST } from 'graphql/route/queries'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'
import { BoatRouteTripStatusDropdown } from 'components/custom/RouteTripStatusDropdown'
import loadingImage from 'assets/images/boat-loading.gif'
import { UPDATE_BOAT_ROUTE_PRICE } from 'graphql/route/mutations'
import { customTimeFormat } from 'utils/common'
import { CaptainIcon } from 'components/icons'

export default function MetroRouteMasterDetails() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { t } = useTranslation()
    const { id } = useParams()
    console.log('id--------', id)
    // Get state object from the URL
    const { navBackTab } = state || {}
    const [searchString, setSearchString] = useState('')
    // Dialog Message
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)

    const [searchTripStatus, setTripSearchStatus] = useState('All')
    const [filterTripList, setFilterTripList] = useState(null)
    const [tripList, setTripList] = useState(null)
    const [routePriceList, setRoutePriceList] = useState([])
    //
    const [routeList, setRouteList] = useState(null)
    const [routeCount, setRouteCount] = useState(0)
    const [activeTab, setActiveTab] = useState(navBackTab ? navBackTab : 'trips')

    const [getMasterRouteList, { loading: routeListLoading, error: routeListError }] = useLazyQuery(
        GET_MASTER_ROUTE_LIST,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getMasterBoatRoute.success && data.getMasterBoatRoute.code === '200') {
                    setRouteList(data.getMasterBoatRoute.master_boat_routes)
                    setRouteCount(data.getMasterBoatRoute.length)
                }
            },
        }
    )
    useEffect(() => {
        searchMasterBoatsRoutes()
    }, [id])

    const handleBack = () => {
        navigate('/metro-master-routes')
    }

    // Search Route  List
    const searchMasterBoatsRoutes = () => {
        getMasterRouteList({
            variables: {
                page: {
                    limit: 1,
                    offset: 0,
                },
                masterRouteId: id,
                routeName: null,
            },
        })
    }
    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
    }
    const handleDialogClose = () => {
        setShowSucDialog(false)
        setShowErrDialog(false)
    }
    useEffect(() => {
        searchMasterBoatsRoutes()
    }, [id])

    console.log(routeList)

    return (
        <>
            <div className="mb-6 flex justify-normal items-center">
                <button
                    onClick={handleBack}
                    type="button"
                    className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <h3 className="text-lg font-bold leading-7 text-primary ps-2.5 pb-1">Route details</h3>
            </div>
            {routeListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {routeListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch routes!')}</div>
                </div>
            )}
            {!routeListLoading && !routeListError && routeList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No route found!')}</div>
                </div>
            )}
            {!routeListLoading && !routeListError && routeList?.length > 0 && (
                <>
                    <div className="flex flex-wrap items-end justify-between gap-4">
                        <div className="max-sm:w-full sm:flex-1">
                            <div className="md:flex md:items-center sm:justify-between md:space-x-5">
                                <div className="flex items-start space-x-5">
                                    <div className="flex-shrink-0">
                                        <div className="relative">
                                            <div className="w-16 h-16 bg-gray-50 p-4 flex justify-center items-center">
                                                <svg
                                                    height="100%"
                                                    viewBox="0 0 512 512"
                                                    width="100%"
                                                    className="fill-primary"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    id="fi_3710370"
                                                >
                                                    <g id="Navigator">
                                                        <path d="m456.59 74.3682a86.939 86.939 0 0 0 -132.2211 112.0053l56.8331 79.5625a17.1 17.1 0 0 0 27.832 0l56.833-79.5625a86.6665 86.6665 0 0 0 -9.277-112.0053zm-61.472 89.9763a28.5 28.5 0 1 1 28.5-28.5 28.5014 28.5014 0 0 1 -28.5 28.5z"></path>
                                                        <path d="m395.118 314.9019a17.0965 17.0965 0 0 0 -17.098 17.0981v36.46a60.4419 60.4419 0 1 1 -120.8838 0v-155.08a94.6382 94.6382 0 1 0 -189.2763 0v80.62a17.0982 17.0982 0 0 0 34.1963 0v-80.62a60.4419 60.4419 0 1 1 120.8837 0v155.08a94.6382 94.6382 0 0 0 189.2764 0v-36.46a17.0965 17.0965 0 0 0 -17.0983-17.0981z"></path>
                                                        <path d="m84.9578 352.9019a55.0981 55.0981 0 1 0 55.0982 55.0981 55.1578 55.1578 0 0 0 -55.0982-55.0981z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                className="absolute inset-0 rounded-lg shadow-inner"
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-1.5">
                                        <h1 className="text-2xl font-bold text-gray-900">
                                            {routeList[0].route_name?.en}
                                        </h1>
                                        <p className="text-sm font-medium text-gray-500">
                                            {routeList[0].waypoints.length} {t('Waypoints')}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex space-y-4 space-y-reverse sm:flex-row-reverse justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                    <button
                                        onClick={() =>
                                            navigate(
                                                `/metro-master-routes/metro-route-master-form/${routeList[0].master_route_id}`
                                            )
                                        }
                                        type="button"
                                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Edit Route')}
                                    </button>
                                </div>
                            </div>

                            <div className="mt-6">
                                <div className="my-6">
                                    <dl className="divide-y divide-gray-100 border rounded-lg overflow-hidden border-gray-200">
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Route Name (EN)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].route_name?.en}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Route Name (AR)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].route_name?.ar}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Route Type')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0]?.route_type?.description?.en ||
                                                    routeList[0].route_type?.code ||
                                                    '-'}
                                            </dd>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">Status</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].status?.description?.en}
                                            </dd>
                                        </div>

                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Waypoints')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                <div className="flex flex-wrap gap-2">
                                                    {routeList[0].waypoints.map((waypoint, index) => {
                                                        return (
                                                            <div
                                                                key={waypoint?.location_id || index}
                                                                className="flex items-center"
                                                            >
                                                                <span className="inline-flex items-center px-4 py-3 text-sm rounded-full bg-gray-50 text-black">
                                                                    {waypoint?.location?.name?.en ||
                                                                        waypoint?.location?.name?.ar ||
                                                                        'Unknown Location'}
                                                                </span>
                                                                {index !== routeList[0].waypoints.length - 1 && (
                                                                    <span className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-white text-primary">
                                                                        <ArrowRightIcon
                                                                            aria-hidden="true"
                                                                            className="-ml-0.5 h-5 w-5"
                                                                        />
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    {submitLoading && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
                        </div>
                    )}
                    {showErrDialog && (
                        <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleErrClose} />
                    )}
                    {showSucDialog && (
                        <SuccessDialog
                            status={true}
                            title={t('Success')}
                            message={t('Updated Successfully')}
                            onClose={handleDialogClose}
                        />
                    )}
                </>
            )}
        </>
    )
}
